var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DatePicker'),_c('el-row',{attrs:{"gutter":10}},[_c('NewSignups'),_c('Videos'),_c('BudgetAllocated')],1),_c('el-row',{attrs:{"gutter":10}},[_c('Campaigns'),_c('Tracks'),_c('BudgetSpent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }